import React, { useState } from "react";
import "./Faqs.scss";
import aboutHero from "../../assets/endpoints.jpg";

const FAQ_ITEMS = [
  {
    q: "What services do you offer?",
    a: "We design and deploy networking (LAN/WAN/Wi-Fi 6), CCTV & access control, server & storage, and endpoints. On the software side we implement ERP/CRM/HRMS and build custom web/mobile apps and integrations.",
  },
  {
    q: "Do you provide free estimates?",
    a: "Yes. We provide no-cost estimates after a short discovery call. For complex scopes we can run a structured assessment that includes a bill of materials and rollout plan.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Absolutely. Our installation teams are certified and we maintain the appropriate business licenses and insurance. Compliance and safety are integral to every engagement.",
  },
  {
    q: "Do you offer post-deployment support?",
    a: "Yes—options range from standard 8×5 to 24×7 with on-call escalation. We include documentation and knowledge transfer at hand-off.",
  },
  {
    q: "Can you customize software to our workflow?",
    a: "We tailor modules and build custom features. Integrations are supported via secure REST/GraphQL APIs and webhooks with audit logging.",
  },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);
  const toggle = (i) => setOpenIdx((p) => (p === i ? -1 : i));

  return (
    <section className="avena-faq-dark">
      <div className="container">
        {/* use custom row spacing + sticky image */}
        <div className="row g-4 align-items-start faqd-row">
          {/* LEFT: narrower, sticky image */}
          <div className="col-12 col-lg-6 faqd-col-left">
            <figure className="faqd-figure faqd-sticky" aria-hidden="true">
              <img src={aboutHero} alt="" />
            </figure>
          </div>

          {/* RIGHT: heading + accordion */}
          <div className="col-12 col-lg-6 faqd-col-right">
            <div className="faqd-label">Common Inquiries</div>
            <h2 className="faqd-title">
              Answers to Your <br /> Hardware & IT Queries
            </h2>

            <div className="faqd-list">
              {FAQ_ITEMS.map((item, i) => {
                const open = i === openIdx;
                return (
                  <div className={`faqd-item ${open ? "is-open" : ""}`} key={i}>
                    <button
                      className="faqd-q"
                      type="button"
                      aria-expanded={open}
                      onClick={() => toggle(i)}
                    >
                      <span className="faqd-num">{i + 1}.</span>
                      <span className="faqd-text">{item.q}</span>
                      <span className="faqd-toggle" aria-hidden="true">
                        <span className="bar h" />
                        <span className="bar v" />
                      </span>
                    </button>

                    <div className="faqd-a" style={{ maxHeight: open ? "240px" : "0px" }}>
                      <p>{item.a}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
